
import PropTypes from 'prop-types'
import { useRef, useEffect, useState } from 'react';
import { isMobile, isInViewPort } from '../misc/constants'

//Always open close to the top of the page
export default function ModalForm(props){
    const [loaded, setLoaded] = useState(false)
    const [y, setY] = useState(document.documentElement.scrollTop || document.body.scrollTop)
    const [closing, setClosing] = useState(false)
    const modalbody = useRef(null);

    const closeModal = () => {
        setClosing(true)
        setTimeout(()=>props.closeAction(),220)
    }

    useEffect(()=>{
        if(loaded && !isInViewPort(modalbody.current)){
            console.log(isInViewPort(modalbody.current))
            props.closeAction && closeModal()
        }
        function onScroll(){
            setY(document.documentElement.scrollTop || document.body.scrollTop)
            if(!loaded){setLoaded(true)}
        }
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    },[y])
    useEffect(()=>{
        if(modalbody && isMobile() && loaded === false){
            modalbody.current.style.top = ((modalbody.current.offsetHeight / 2) + 10 + y) + "px";
        }
    })
    return(
        <div id="modal-form-wrapper" onClick={()=>{props.closeAction && closeModal()}} className={`${closing ? 'closing': ''}`}>
            <div className="modal-form" onClick={e => e.stopPropagation()} ref={modalbody}>
                <div className="icon fa close" onClick={()=>{props.closeAction && closeModal()}}></div>
                <div className="content">{props.children}</div>
            </div>
        </div>
    )
}

ModalForm.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    closeAction: PropTypes.func
}

